/**
 * Pages only administrators may open (Statistics, Simulator, Simulations). Checked when the page is created: a guard
 * in beforeRouteEnter alone is not enough, because on a direct page load its callback can run before the stored
 * session is known (the app shows a splash meanwhile) and nobody is sent away.
 */
export default {
  async created() {
    const store = this.$store;
    if (!store.getters['user/getWeb2ActiveAccount']) await store.dispatch('user/initWeb2').catch(() => {});
    const account = store.getters['user/getWeb2ActiveAccount'];
    if (!account || !account.role || account.role.name !== 'Administrator') this.$router.replace('/').catch(() => {});
  },
};
